import React,{Component} from 'react';
import $ from 'jquery';
import { Link, browserHistory } from 'react-router';
import { ButtonToolbar, MenuItem, Panel,DropdownButton,Modal,Button  } from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';
import InfiniteScroll from 'react-infinite-scroll-component';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

// /pdeals/:BrandName/:CatName/:Tid/:Type/:DType
// /pdeals/:Type/:CatName/:Tid

export default class ProductDetails extends Component {
	  constructor(props){
	    super(props);
	      this.state={
	          tid : this.props.params.Tid,
	          type: this.props.params.Type,
	          dtype: this.props.params.DType,
	          pdeals: [],
	          totdata: '',
	          prevPath: '',
	          brands: [],
	          categories: [],
	          brands_status: false,
	          cat_status: false,
	          cat_sort_status:false,
	          nodata: false,
	          open: false,
	          web_title: '',
	          web_desc: '',
	          loadmore_number: 2,
	          loadmore_status: 0,
	          set_type:'',
	          next_page:'',
	          sort_list:[],

	          cart_count:0,
	          sort_title:'Sort By',
	          seo_title:'',
          	  seo_desc: '',
          	  loading_gif:false,
			  loading_more_status:false,
          	  
          	  deal_type_status:false,
          	  deal_types:[],
          	  ad_guarantee_flag:0,
          	  mob_loading:false,
		  };
	      this.getBrands=this.getBrands.bind(this);
	      this.getSelectedBrand=this.getSelectedBrand.bind(this);
	      this.loadMoreDeals=this.loadMoreDeals.bind(this);
	      this.getDeviceId=this.getDeviceId.bind(this);
	      this.getSelectedCategorySort=this.getSelectedCategorySort.bind(this);
	      this.getCartCount=this.getCartCount.bind(this);
	      this.fetchData=this.fetchData.bind(this);
	      this.refresh=this.refresh.bind(this);
	      this.getSelectedDType=this.getSelectedDType.bind(this);
	   // this.getCategories=this.getCategories.bind(this);
	  };
		componentDidMount()
		{
				window.scrollTo(0, 0);		
		  		// /pdeals/:BrandName/:CatName/:Tid/:Type/:DType
				// /pdeals/:Type/:CatName/:Tid
				if(screen.width >= 800)
			    {
			     	if(this.props.params.DTpe)
			     	{
			     		window.location.href="/web/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType;	
			     	}
			    }
			    if(this.props.params.BrandName && this.props.params.CatName && this.props.params.Tid && this.props.params.Type && this.props.params.DType)
			    {
			    	localStorage.setItem('m_r_p_deals',"/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType)	
			    }
			    if(!this.props.params.BrandName && !this.props.params.DType && this.props.params.Tid)
			    {
			    	localStorage.setItem('m_r_p_deals','/pdeals/'+this.props.params.Type+'/'+this.props.params.CatName+'/'+this.props.params.Tid);
			    }
			    // else
			    // {
			    // 	localStorage.removeItem('m_r_p_deals');	
			    // }
			    if(localStorage.user_id && localStorage.token)
			    {
			      this.getCartCount();
			    }

			    this.getDeviceId();
			    localStorage.removeItem('m_r_e_coupon_dt');
			    localStorage.removeItem('m_r_s_dt');
			    localStorage.removeItem('m_r_p_dt');
			    localStorage.removeItem('m_r_e_s_dt');
			    localStorage.removeItem('m_r_e_p_dt');
			    localStorage.removeItem('w_r_p_deals')
			    localStorage.removeItem('w_r_s_deals');
			    localStorage.removeItem('m_r_s_deals');
			    localStorage.removeItem('subdeals');
			    //localStorage.removeItem('m_r_p_deals');
			    localStorage.removeItem('bid');
			    localStorage.removeItem('cat_sort');
			    localStorage.removeItem('url');
			    
			    this.getBrands();
		      	
			    var data1= '';
			    var data2= '';
		      	var get_function= '';
		      	var uid =0;
			    if(localStorage.user_id)
			    {
			       uid=localStorage.getItem('user_id')
			    }
			    else
			    {
			       uid=0;
			    }
			    if(this.state.type === 'tag')
			    {
			      data1={from:'mobile_web',uid:uid,type:'tag',dtype:2,tid:this.props.params.Tid};
			      data2=JSON.stringify(data1);
			      get_function='getProductbycat_brand';
			      this.get_product_list(data2,baseUrl,get_function);
			    }
			    if(this.state.type === 'offers')
			    {
			          data1= {from: 'mobile_web',uid:uid,deal_offer_type: this.state.dtype, type: ''};
			          data2= JSON.stringify(data1);
			          get_function='getProductbycat_brand';
			          this.get_product_list(data2,baseUrl,get_function);
			    }
		    	var get_cat_id=0;
			    if(localStorage.cat_id)
			    {
			      get_cat_id=localStorage.getItem('cat_id');
			    }
			    else
			    {
			      get_cat_id=0;
			    }
			    if(this.state.type === 'Pcategory')
		    	{
			        data1={from: 'mobile_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:this.state.dtype,cat_id: get_cat_id,deal_ids:this.props.params.Dids};
			        data2=JSON.stringify(data1);
			        get_function='getProductbycat_brand';
			        this.get_product_list(data2,baseUrl,get_function);  
			    }
			    if(this.state.type === 'brand')
			    {
			        data1={from: 'mobile_web',uid:uid,type:this.state.type, tid:this.state.tid,dtype:this.state.dtype,cat_id: get_cat_id};
			        data2=JSON.stringify(data1);
			        get_function='getProductbycat_brand';
			        this.get_product_list(data2,baseUrl,get_function);
			    }
			    // else
			    // {
			    //     data1= {discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type};
			    //     data2= JSON.stringify(data1);get_function='getNewsearch';
			    //     this.get_product_list(data2,baseUrl,get_function);
			    // }
		}
	  	refresh()
	  	{
	  		console.log("");
	  	}
	   	fetchData()
	  	{
		      // this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
		      var num=this.state.next_page;
		      var type=this.state.set_type;
		      if(this.props.params.DType)
		      {
		      	var dtype=this.props.params.DType;
		      }
		      else
		      {
		      	dtype=0;
		      }
		      // var dtype=this.props.params.DType;
		      var tid=this.props.params.Tid;
		      
		      if(localStorage.user_id)
		      {
		         var  uid=localStorage.getItem('user_id')
		      }
		      else
		      {
		         uid=0;
		      }
		      this.setState({
			      // loading_gif:true,
			      loading_more_status:true,
			      mob_loading:true,
			  })
		      
		      var getfunc="";
		      var data1="";
		      var data2="";
		      type =this.props.params.Type;
		      if(type==="all")
		      {
		        data1={from :'mobile_web',uid:uid,page:num,type:dtype,limit:20};
		        data2=JSON.stringify(data1);
		        getfunc="getPoductDeals";
		      }
		      if(type==="Pcategory")
		      {
		        data1={from: 'mobile_web',uid:uid,page:num,dtype:dtype, type:type,tid:tid,limit:20};
		        data2=JSON.stringify(data1);
		        getfunc="getProductbycat_brand";
		      }
		      if(type==="brand")
		      {
		        data1={from:'mobile_web',uid:uid,page:num,dtype:dtype,type:type,tid:tid,limit:20};
		        data2=JSON.stringify(data1);
		        getfunc="getProductbycat_brand";
		      }
		      if(type==="partner")
		      {
		      	data1={from:'mobile_web',uid:uid,page:num,dtype:0,type:type,tid:tid,limit:20};
		        data2=JSON.stringify(data1);
		        getfunc="getProductbycat_brand";	
		      }
		      else
		      {
		      	data1={from:'mobile_web',uid:uid,page:num,dtype:dtype,type:type,tid:tid,limit:20};
		        data2=JSON.stringify(data1);
		        getfunc="getProductbycat_brand";
		      }
		      if(this.state.loadmore_status===1)
		      {
		            this.setState({
		              // loading_gif:true,
		              loadmore_status:true,
		              mob_loading:true,
		            })
		            $.ajax({
		                  method:'POST',
		                  dataType:'json',
		                  data:{req:data2},
		                  url:baseUrl+getfunc,
		                  success:function(data)
		                  {
		                      if(data.products)
		                      {
		                          if(data.load_more===1 || data.products.length > 0)
		                          {
		                            this.setState({
		                            	pdeals:this.state.pdeals.concat(data.products),
		                                offer: data,
		                                todata: data,
		                                loadmore_status:data.load_more,
		                                set_type:data.set_type,
		                                next_page:data.next_page,
		                                loading_gif:false,
		                                loading_more_status:false,
		                                mob_loading:false,
		                            });
		                          }
		                          else
		                          {
		                              this.setState({
		                                  set_type:data.set_type,
		                                  next_page:data.next_page,
		                                  loadmore_status:data.load_more,
		                                  loading_gif:false,
		                                  loading_more_status:false,
		                                  mob_loading:false,
		                              });
		                          }
		                      }
		                      else
		                      {
		                        if(data.load_more===1 || data.result.length > 0)
		                        {
		                              this.setState({
		                                  pdeals:this.state.pdeals.concat(data.result),
		                                  // feedsList: this.state.feedsList.concat(data.result),
		                                  set_type:data.set_type,
		                                  next_page:data.next_page,
		                                  loadmore_status:data.load_more,
		                                  loading_gif:false,
		                                  loading_more_status:false,
		                                  mob_loading:false,
		                              });
		                          } 
		                          else
		                          {
		                              this.setState({
		                                  set_type:data.set_type,
		                                  next_page:data.next_page,
		                                  loadmore_status:data.load_more,
		                                  loading_gif:false,
		                                  loading_more_status:false,
		                                  mob_loading:false,
		                              });
		                          }
								}
								
		                  }.bind(this),
		                  error:function(err)
		                  {
		                      this.setState({
		                        loading_gif:false,
		                        loading_more_status:false,
		                        mob_loading:false,
		                      })
		            	  }
		        	});
	      	  }
		      else
		      {
		      	this.setState({
		      		loading_more_status:false,
		      		mob_loading:false,
		      	})
		      }
	    }
	    getCartCount()
	    {
          	if(localStorage.user_id)
	      	{
	        	var uid=localStorage.getItem('user_id')
	     	}
	      	else
	      	{
	         	uid=0;
	      	}
		    var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token')};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		          method: 'POST',
		          url: baseUrl+'cart_count',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
		            this.setState({
		                cart_count:data.cart_count,
		            });
		          }.bind(this),
		          error: function(err){
		          
		          }
		    });
	  	}
	  	getDeviceId()
	  	{
	      if(localStorage.user_id)
	      {
	          var uid=localStorage.user_id;
	      }
	      else
	      {
	        	uid=0;
	      }
	      var data1={from:'mobile_web',id:uid, device_id: localStorage.getItem('push_device_id')}
	      var data2=JSON.stringify(data1);
	      $.ajax({
	          method: 'POST',
	          url: baseUrl+'getDeviceId',
	          dataType: 'json',
	          data:{req: data2},
	          success: function(data)
	          {
	            
	          },
	          error: function(err){
	          }
	      });
	    }
	    loadMoreDeals(num,type,tid,dtype)
	    {
		    var getfunc="";
		    var data1="";
		    var data2="";
		    var uid =0;
		    if(localStorage.user_id)
		    {
		       uid=localStorage.getItem('user_id')
		    }
		    else
		    {
		       uid=0;
		    }
		    if(type==="all")
		    {
		      // alert(type);
		      data1={from :'mobile_web',uid:uid,page:num,type:dtype};
		      data2=JSON.stringify(data1);
		      getfunc="getPoductDeals";
		    }
		    if(type==="Pcategory")
		    {
		      data1={from: 'mobile_web',uid:uid,page:num, dtype:dtype, type:type,tid:tid, bid:localStorage.brand};
		      data2=JSON.stringify(data1);
		      getfunc="getProductbycat_brand";
		    }
		    if(type==="brand")
		    {
		      data1={from:'mobile_web',uid:uid,page:num,dtype:dtype,type:type,tid:tid,cat_id:localStorage.cat_id};
		      data2=JSON.stringify(data1);
		      getfunc="getProductbycat_brand";
		    }
		    
		    var products="";
		    $.ajax({
		          method: 'POST',
		          url: baseUrl+getfunc,
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
		              this.setState({
		                  totdata: data,
		                  loadmore_status:data.load_more,
		                  set_type: data.set_type,
		                  next_page:data.next_page,
		              });
		              this.setState({ 
		                  pdeals: this.state.pdeals.concat(data.result),
		              });
		          }.bind(this),
		          error:function(err)
		          {
		            // console.log(err);
		          }
		    });
	  		return products;
	    }
	    getBrands()
	    {
		    if(this.props.params.DType)
		    {
		    	var dtype=this.props.params.DType;
		    }
		    else
		    {
		    	dtype=0;
		    }
		    var data1={from: 'mobile_web',type:this.state.type,tid: this.state.tid,dtype:dtype};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		          method: 'POST',
		          url: baseUrl+'filterBrandCat',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
		            if(data.brands_lst.length > 1)
		            {
		              this.setState({
		                brands_status: true,
		              });
		            }
		            if(data.cat_lst.length > 1)
		            {
		              this.setState({
		                cat_status: true,
		              });
		            }
		            if(data.deal_types.length > 1)
					{
						this.setState({
							deal_type_status:true,
						})
					}
		            this.setState({
		              brands:data.brands_lst,
		              categories: data.cat_lst,
		              sort_list: data.sort,
		              deal_types:data.deal_types,
		            });
		         }.bind(this),
		         error: function(err)
		         {
		         }
		    });
	    }
	    getSelectedBrand(b)
	    {
		    this.setState({
		    	loading_gif:true,
		    });
		    localStorage.setItem('brand',b);
			var uid =0;
			if(localStorage.user_id)
			{
			   uid=localStorage.getItem('user_id')
			}
			else
			{
			   uid=0;
			}
		    if(this.state.type==="offers")
		    {
		  		var data1={from:"mobile_web","tid":"","type":"combo","cat_id":"cat_id","uid":uid,"deal_offer_type":"3","bid":b,"lat1":"","long1":"","sort":localStorage.getItem('cat_sort')}  	
		    }
		    else
		    {
		    	data1={from: 'mobile_web',uid:uid,type:this.state.type, tid: this.state.tid,dtype:this.state.dtype,bid: b};
		    }
		    var data2=JSON.stringify(data1);
		    $.ajax({
		          method: 'POST',
		          url: baseUrl+'getProductbycat_brand',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
			            if(data.result.length === 0)
			            {
			              this.setState({
			                nodata: true,
			                loading_gif:false,
			              });
			            }
			            else
			            {
			              this.setState({
			                nodata: false,
			                loading_gif:false,
			              });
			            }
			            this.setState({
			              pdeals:data.result,
			              totdata: data,
			              loadmore_status:data.load_more,
			              set_type:data.set_type,
			              next_page:data.next_page,
			            });
					if(data.status==='error')
					{
						localStorage.removeItem('cat_id');
					}
		          }.bind(this),
		          error: function(err)
		          {
		          }
		    });
	    }
	    getSelectedCategory(c)
	    {
		   	this.setState({
		   		loading_gif:true,
		   	});
		    localStorage.setItem('cat_id',c);
		    localStorage.removeItem('brand');
		    var uid =0;
	      	if(localStorage.user_id)
	      	{
		        uid=localStorage.getItem('user_id')
		    }
	      	else
	      	{
	        	uid=0;
	      	}
		    var data1={from: 'mobile_web',uid:uid,type:this.state.type,tid:this.state.tid, dtype:this.state.dtype,cat_id: c};
		    var data2=JSON.stringify(data1);
			$.ajax({
		          method: 'POST',
		          url: baseUrl+'getProductbycat_brand',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
			            if(data.result.length === 0)
			            {
			              this.setState({
			                nodata: true,
			                loading_gif:false,
			              })
			            }
			            else
			            {
			              this.setState({
			                nodata: false,
			                loading_gif:false,
			              })
			            }
			            this.setState({
			                pdeals:data.result,
			                totdata: data,
			                loadmore_status:data.load_more,
			                set_type:data.set_type,
			                next_page:data.next_page,
			           });
		          }.bind(this),
		          error: function(err)
		          {
		          }
		    });
	    }
	    getSelectedCategorySort(c,name)
	    {
	  		this.setState({
	  			loading_gif:true,
	  		});
		    // localStorage.removeItem('brand');
		    var catId=0;
		    localStorage.setItem('cat_sort',c);
		    
		    if(localStorage.cat_id)
		    {
		      catId=localStorage.getItem('cat_id');
		    }
		    else
		    {
		      catId=0;
		    }
		    this.setState({
		    	sort_title: name,
		    });
		    var uid =0;
		    if(localStorage.user_id)
		    {
		      uid=localStorage.getItem('user_id')
		    }
		    else
		    {
		       uid=0;
		    }
		    if(this.state.type === 'offers')
		    {
		    	var data1={from:"mobile_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":c}
		    }
		    else {
		    	 data1={from: 'mobile_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype,cat_id:catId,sort:c};
		    }
		    var data2=JSON.stringify(data1);
			$.ajax({
		          method: 'POST',
		          url: baseUrl+'getProductbycat_brand',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
			            if(data.result.length === 0)
			            {
			              this.setState({
			                nodata: true,
			                loading_gif:false,
			              })
			            }
			            else
			            {
			              this.setState({
			                nodata: false,
			                loading_gif:false,
			              })
			            }
			            this.setState({
			                pdeals:data.result,
			                totdata: data,
			                loadmore_status:data.load_more,
			                set_type:data.set_type,
			                next_page:data.next_page,
			           });
			           localStorage.removeItem('cat_sort');
			           localStorage.removeItem('cat_id');
		          }.bind(this),
		          error: function(err)
		          {
		          }
		    });
	    }

	    getSelectedBrandSort(b,name)
	    {
		   	this.setState({
		   		loading_gif:true,
		   	});
		    // localStorage.removeItem('brand');
		    var bid=0;
		    localStorage.setItem('bid_sort',b);
		    if(localStorage.brand)
		    {
		      bid=localStorage.getItem('brand');
		    }
		    else
		    {
		      bid=0;
		    }
		    this.setState({
		    	sort_title: name,
		    });
		    var uid =0;
		    if(localStorage.user_id)
		    {
		       uid=localStorage.getItem('user_id')
		    }
		    else
		    {
		      uid=0;
		    }
		    if(this.state.type === 'offers')
		    {
		    	var data1={from:"mobile_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":b}
		    }
		    else {
		    	 data1={from: 'mobile_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype,bid:bid,sort:b};
		    }
		    var data2=JSON.stringify(data1);
			$.ajax({
		          method: 'POST',
		          url: baseUrl+'getProductbycat_brand',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
			            if(data.result.length === 0)
			            {
			              this.setState({
			                nodata: true,
			                loading_gif:false,
			              })
			            }
			            else
			            {
			              this.setState({
			                nodata: false,
			                loading_gif:false,
			              })
			            }
			            this.setState({
			                pdeals:data.result,
			                totdata: data,
			                loadmore_status:data.load_more,
			                set_type:data.set_type,
			                next_page:data.next_page,
			           });
		          }.bind(this),
		          error: function(err)
		          {
		          }
		    });
	    }
	    getSelectedDType(dtype)
	    {
	  		this.setState({
	  			loading_gif:true,
	  		});
		    // localStorage.removeItem('brand');
		    // var catId=0;
		    
		    if(localStorage.user_id)
		    {
		     	var uid=localStorage.getItem('user_id')
		    }
		    else
		    {
		        uid=0;
		    }
		    if(this.state.type === 'offers')
		    {
		    	var data1={from:"mobile_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":''}
		    }
		    else
		    {
		    	 data1={from: 'mobile_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:dtype,sort:''};
		    }
		    var data2=JSON.stringify(data1);
			$.ajax({
		          method: 'POST',
		          url: baseUrl+'getProductbycat_brand',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
			            if(data.result.length === 0)
			            {
			              this.setState({
			                nodata: true,
			                loading_gif:false,
			              })
			            }
			            else
			            {
			              this.setState({
			                nodata: false,
			                loading_gif:false,
			              })
			            }
			            this.setState({
			                pdeals:data.result,
			                totdata: data,
			                loadmore_status:data.load_more,
			                set_type:data.set_type,
			                next_page:data.next_page,
			           });
		          }.bind(this),
		          error: function(err)
		          {
		          }
		    });
	    }
	  
	    get_product_list(data2,baseUrl,get_function)
	    {
	        this.setState({
	       		mob_loading:true,
	        })
	        $.ajax({
	            method: 'POST',
	            url: baseUrl+get_function,
	            dataType:'json',
	            data: {req:data2},
	            success: function(data)
	            {
		              if(data.result.length === 0)
		              {
		                this.setState({
		                  nodata: true,
		                  mob_loading:false,
		                });
		              }
		              else
		              {
		                this.setState({
		                  nodata: false,
		                  mob_loading:false,
		                })
		              }
		            this.setState({
		                pdeals:data.result,
		                totdata: data,
		                loadmore_status:data.load_more,
		                set_type:data.set_type,
		                next_page:data.next_page,
		                seo_desc:'',
		                mob_loading:false,
		            });
		            if(this.props.params.Type === "Pcategory")
		        	{ 
			              if(this.props.params.BrandName==="feed")
			              {
			                document.title ='Buy Aqua '+data.cat_name+' Feed Products Online | AquaDeals';
			                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
			                
			              } 
			              else if(this.props.params.BrandName==="health-care")
			              {
			                document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
			                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
			              }
			              else if(this.props.params.BrandName==="aerators")
			              {
			                document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
			                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
			          	  }
			              else
			              {
			                  document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
			                  document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
			              }
		        	}
		            else if (this.props.params.Type === 'brand')
		            {
			              if(this.props.params.BrandName==="feed")
			              {
			                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
			                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture Fish / Vannamei Shrimp " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
			                
			              }
			              else if(this.props.params.BrandName==="health-care")
			          	  {
			            	document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
			            	document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture Fish / Vannamei Shrimp " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
			          	  }
			          	  else if(this.props.params.BrandName==="aerators")
			              {	
			                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
			                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
			                
			              }
			              else
			              {
			                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
			                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture Fish / Vannamei Shrimp " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
			                
			              }            
			        }
			        if(data.status==='error')
			        {
				        if(this.props.params.DType==="2" && this.props.params.Type !=='all')
			            {
			              var nodata_red_url='/pdeals/feed/all/2';
			            }
			            else if(this.props.params.DType==="4" && this.props.params.Type !=='all')
			            {
			                nodata_red_url='/pdeals/health-care/all/4';
			            }
			            else if(this.props.params.DType==="3" && this.props.params.Type !=='all')
			            {
			                nodata_red_url='/pdeals/machine-equip/all/3';
			            }
			            else if(this.props.params.DType==="5" && this.props.params.Type !=='all')
			            {
			                nodata_red_url='/pdeals/hatchery-machinery/all/5';
			            }
			            else if(this.props.params.DType==="7" && this.props.params.Type !=='all')
			            {
			                nodata_red_url='/pdeals/hatchery-health-care/all/7';
			            }
			            else
			            {
			                nodata_red_url='/home';
			            }
				            browserHistory.push(nodata_red_url);
				            location.reload();
				        }
				        this.setState({
				        	mob_loading:false,	
				        });
		          }.bind(this),
		          error: function(err)
		          {
				  }
	      	});
	    }


  render()
  {
  	$('body').css('background','#fff');
    var products = this.state.pdeals.map((product,index) => (<ProductsList key={product.pid} data={product} onUpdate={()=>this.getCartCount()} />));
    return (
	  <div className="mob_deals pdeals_page mob_pdeals_page">
	    <div className="page_hdr">
	      <div className="container-fluid">
	        <h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>{this.state.totdata.cat_name ?  this.state.totdata.cat_name : ''} </h5>
	        <a href="/" title="Home" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
	       	<a className="mob_cart_btn" href="/mycart">
				<img alt="" src={baseAssets+'icons/web_icons/cart_icon.png'} />
				{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
			</a>
	       {/*<a title="My Cart" href="/mycart" className="mob_cart_logo"><img src={baseAssets+'icons/web_icons/cart_icon.png'} alt=" " /></a> */}
		  </div>
	    </div>
	    {this.state.mob_loading ? <div className="mob_loading"><img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" /></div> : ''}
	    <div className="pag_cntnt">&nbsp;</div>
	    {this.state.loading_gif ? <i className="mob_loading"><img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" /></i> : ''}
	    <section className="">
	    	{/*{this.state.nodata ? <div className="no_data">
	        <h3>No Deals Available</h3>
	        <p>Need something here ? <Link to={"/customer_care"}>CONTACT US</Link> now !</p>
	        </div> : products }*/}
	        {this.state.nodata ? <div className="no_data">
	        <h3>No Deals Available</h3>
	        <p>Need something here ? <Link to={"/customer_care"}>CONTACT US</Link> now !</p>
	        </div> : ''}
	        <InfiniteScroll
		          pullDownToRefresh
		          pullDownToRefreshContent={
		            <h3 style={{textAlign: 'center'}}>&#8595;</h3>
		          }
		          releaseToRefreshContent={
		            <h3 style={{textAlign: 'center'}}>&#8593;</h3>
		          }
		          refreshFunction={this.refresh}
		          next={this.fetchData}
		          hasMore={true}
		          scrollThreshold={0.8}
		          loader={<h4></h4>}
		          endMessage={
		            <p style={{textAlign: 'center'}}>
		              <b></b>
		            </p>
		          }>
		          {products}
		    </InfiniteScroll>
	        {this.state.loading_more_status  ? <div className="loading_more_sym"><img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" /></div> : ''}
	        {/*  {this.state.loadmore_status === 1  ? <div className="mob_loadmore_button" onClick={()=>{this.setState({ loadmore_number : this.state.loadmore_number+1 }); this.loadMoreDeals(this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType)}}><i className="glyphicon glyphicon-circle-arrow-down"></i>Load More Deals</div> : ''} */}
	    </section>
	    <div className="clr">&nbsp;</div>
	    <div className="clr">&nbsp;</div>
	    <div className="clr">&nbsp;</div>
	    <div className="clr">&nbsp;</div>
	    <section className="seed_sort dsl_srt">
	        <ul>
	          {this.state.cat_status ?  
	            <li className="col-md-6 col-xs-6 col-sm-6 ">
	                <ButtonToolbar>
	                    <DropdownButton className="test_filter_4" noCaret onClick={this.getSorts} title={this.state.sort_title} dropup>
	                        <MenuItem header>Sort By</MenuItem>{this.state.sort_list.map((cat,index) => (<MenuItem className="seed_list1" eventKey={cat.id} onClick={()=>this.getSelectedCategorySort(cat.id,cat.name)} >{cat.name}</MenuItem>))}
	                    </DropdownButton>
	                </ButtonToolbar>
	            </li> : 
	            <li className="col-md-6 col-xs-6 col-sm-6 ">
	                <ButtonToolbar>
	                    <DropdownButton className="test_filter_4" noCaret onClick={this.getSorts} title={this.state.sort_title} dropup>
	                        <MenuItem header>Sort By</MenuItem>{this.state.sort_list.map((cat,index) => (<MenuItem className="seed_list1" eventKey={cat.id} onClick={()=>this.getSelectedBrandSort(cat.id,cat.name)} >{cat.name}</MenuItem>))}
	                    </DropdownButton>
	                </ButtonToolbar>
	                {/* <li className="col-md-6 col-xs-6 col-sm-6 coast_list1 fltr_dbl ">
	                		<div className="fltr_dbl"><img src={baseAssets+'images/web_imgs/bybrands2.png'} alt="aqua" /><span>By Brand</span></div>
	            		</li> */}
	            </li>
	          }
	          {this.state.brands_status ?
	          	 <li className="col-md-6 col-xs-6 col-sm-6 coast_list1">
	                <ButtonToolbar>
	                    <DropdownButton className="test_filter_1" noCaret onClick={this.getBrands} title="By Brand" dropup >
	                        <MenuItem header>By Brand ({this.state.brands.length})</MenuItem>{this.state.brands.map((brand,index) => (<MenuItem eventKey={brand.id} className="seed_list1" onClick={()=>this.getSelectedBrand(brand.id)} >{brand.name}</MenuItem>))} 
	                    </DropdownButton> 
	                </ButtonToolbar>
	            </li>: ''}

	            {this.state.cat_status ? 
	            	<li className="col-md-6 col-xs-6 col-sm-6 coast_list2">
		                <ButtonToolbar>
		                    <DropdownButton className="test_filter_2" noCaret onClick={this.getCoasts} title="By Category" dropup>
		                        <MenuItem header>By Category </MenuItem>{this.state.categories.map((cat,index) => (<MenuItem className="seed_list1" eventKey={cat.id} onClick={()=>this.getSelectedCategory(cat.id)} >{cat.name}</MenuItem>))}
		                    </DropdownButton>
		                </ButtonToolbar>
	              	</li>
	 			: ''}

	            {this.state.deal_type_status ? <li className="col-md-6 col-xs-6 col-sm-6 coast_list2">
	                  <ButtonToolbar>
	                      <DropdownButton className="test_filter_2" noCaret onClick={this.getCoasts} title="By Type" dropup>
	                          <MenuItem header>By Type </MenuItem>{this.state.deal_types.map((cat,index) => (<MenuItem className="seed_list1" eventKey={cat.id} onClick={()=>this.getSelectedDType(cat.id)} >{cat.name}</MenuItem>))}
	                      </DropdownButton>
	                  </ButtonToolbar>
	              </li>: ''}
	        </ul>
	    </section>
	  </div>
    );
  }
}

class ProductsList extends Component {
  constructor(props){
    super(props);
    this.state={
      open: false,
      msg: '',
      shareUrl: '',
      cart_count:'',
      clearcart_status:false,
      already_added_status:false,
    };
    this.ShareFunc=this.ShareFunc.bind(this);
    this.addToCart=this.addToCart.bind(this);
    this.updateCartCount=this.updateCartCount.bind(this);
    this.close=this.close.bind(this);
    this.replaceCartItems=this.replaceCartItems.bind(this);
    this.addToQuickCart=this.addToQuickCart.bind(this);
    this.addToQuickCart_Onload=this.addToQuickCart_Onload.bind(this);
  }
  	componentDidMount()
  	{
  		if(localStorage.user_id && localStorage.token && localStorage.quickbuy_onload)
	    {
	    	this.addToQuickCart_Onload();
	    	localStorage.removeItem('quickbuy_onload');
			localStorage.removeItem('quickbuy_deal_id');	
	    }
  	}
  	addToQuickCart_Onload()
	{
	  	if(!localStorage.user_id && !localStorage.token)
	  	{
	  		localStorage.setItem('quickbuy_onload','1');
	  		// localStorage.setItem('quickbuy_deal_id',deal_id);
	  		browserHistory.push('/login');
		}
		else
		{
			if(localStorage.user_id)
			{
				var uid=localStorage.user_id;
			}
			else
			{
				uid=0;
			}
			if(localStorage.quickbuy_deal_id)
			{
				var deal_id=localStorage.quickbuy_deal_id;
			}
			else
			{
				deal_id=0;
			}
			if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }

			var data1={from:'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				dataType:'json',
				url: baseUrl+'addToQCart',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==="success")
					{
						this.updateCartCount();
						browserHistory.push('/quickcart');
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}
					else if(data.status==="error" && data.cart_flag===0)
					{
						this.setState({
							clearcart_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}
					else if(data.status==="error" && data.message==="Product already added to the cart")
					{
						this.setState({
							already_added_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}
					localStorage.removeItem('quickbuy_onload');
					localStorage.removeItem('quickbuy_deal_id');
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
		localStorage.removeItem('quickbuy_onload');
		localStorage.removeItem('quickbuy_deal_id');
	}

  replaceCartItems(deal_id,quantity)
  {
	  	if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
	  	var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,quantity:quantity,pl_size:0,salinity:0,pickup_date:0,source:source,campaign:campaign,url_id:url_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success")
				{
					this.setState({
						clearcart_status:false,
					});
					browserHistory.push('/mycart');
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
  }
  close()
  {
	  	this.setState({
	  		clearcart_status:false,
	  		already_added_status:false,
	  	});
  }
  updateCartCount()
  {
  	this.props.onUpdate();
  }
  ShareFunc(evnt)
  {
	    var data1={from: 'mobile_web',type:1,did:evnt};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'createTinyurl',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            this.setState({
	                msg: data.msg,
	                shareUrl: data.tinyurl,
	            });
	          }.bind(this),
	          error: function(err)
	          {
	            
	          }
	    });
	    this.setState({
	      open: !this.state.open 
	    });
	    setTimeout(() => {this.setState({open: false}); }, 5000);
  }
  addToQuickCart(deal_id)
  {
	  	if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
	  	if(!localStorage.user_id && !localStorage.token)
	  	{
	  		localStorage.setItem('quickbuy_onload','1');
	  		localStorage.setItem('quickbuy_deal_id',deal_id);
	  		browserHistory.push('/login');
		}
		else
		{
			var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				dataType:'json',
				url: baseUrl+'addToQCart',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==="success")
					{
						this.updateCartCount();
						browserHistory.push('/quickcart');
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}
					else if(data.status==="error" && data.cart_flag===0)
					{
						this.setState({
							clearcart_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}
					else if(data.status==="error" && data.message==="Product already added to the cart")
					{
						this.setState({
							already_added_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}
					localStorage.removeItem('quickbuy_onload');
					localStorage.removeItem('quickbuy_deal_id');
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
  }
  
  addToCart(deal_id)
  {
	  	if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
	  	if(!localStorage.user_id && !localStorage.token)
	  	{
	  		browserHistory.push('/login');
		}
		else
		{
			var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				dataType:'json',
				url: baseUrl+'quickBuy',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==="success")
					{
						this.updateCartCount();
						browserHistory.push('/mycart');
					}
					else if(data.status==="error" && data.cart_flag===0)
					{
						this.setState({
							clearcart_status: true,
						});
					}
					else if(data.status==="error" && data.message==="Product already added to the cart")
					{
						this.setState({
							already_added_status: true,
						});
					}
					else if(data.status==="error" && data.message==="Token mismatch")
					{
						localStorage.removeItem('token');
						localStorage.removeItem('user_id');
						browserHistory.push('/login');
					}
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
  }

  render()
  {
    var mydata=this.props.data;
    var shareUrl = this.state.shareUrl;
    var title = "Hey Click here "+ shareUrl+ " to check "+ mydata.title + " from AquaDeals.";
    var description = shareUrl;
    return (
      <div className={"list_card"} >
  	{mydata.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+mydata.promo_ribbion} alt="" /></i> : ''}
  	{mydata.dealcount >= 2 ? 
    <Link to={"/subdeals/"+mydata.url_dtype_name+"/"+mydata.url_cat_name+"/"+mydata.dtype+"/"+mydata.url_brand_name+"/"+mydata.pid} >  
        <div className="list_img">
            <img src={mydata.image ===null ? baseAssets+'images/product_imgs/noimage1.jpg' : baseAssets+'images/product_imgs/'+mydata.image} alt="" />
        </div>
        {mydata.ad_guarantee_flag==='1' ? <span className="pdeals_adguarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt=" " /></span> : ''}
        <div className="list_txt">
            <h4>{mydata.title+' '+mydata.quantity}</h4>
            {mydata.brand_name ? <h5>{mydata.brand_name}</h5> : ''}
            {mydata.dealcount >=2 ? <h3>{mydata.dealcount} deals available</h3> : ''}
            {/* {mydata.pricediff ==="" ? <h3>MRP &#8377; {mydata.mrp}</h3> : ''} */}
            {mydata.over_rate >=1 ? <h6><i className="m_star_rate"><img src={baseAssets+'images/web_imgs/star_filled.png'} width="16px" role="presentation"/></i>{mydata.over_rate}</h6>: <h6><i className="m_nostar_rate"><img src={baseAssets+'images/web_imgs/star_gray.png'} width="17px" role="presentation"/></i></h6>}
		</div>
    </Link> : 
    <Link to={"/pdetails/"+mydata.url_dtype_name+"/"+mydata.url_cat_name+"/"+mydata.url_brand_name+"/"+mydata.url_product_name+"/"+mydata.pid+"/"+mydata.deal_id} >
        <div className="list_img">
            <img src={mydata.image ===null ? baseAssets+'images/product_imgs/noimage1.jpg' : baseAssets+'images/product_imgs/'+mydata.image} alt=" " />
        </div>
        {mydata.ad_guarantee_flag==='1' ? <span className="pdeals_adguarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt=" " /></span> : ''}
        <div className="list_txt">
            <h4>{mydata.title} {mydata.quantity}</h4>
            {mydata.brand_name ? <h5>{mydata.brand_name}</h5> : ''}
            {mydata.pricediff ==="" ? <h3>MRP &#8377; {mydata.mrp}</h3> : ''}
            {mydata.dealcount >=2 ? <h3>{mydata.dealcount} deals available</h3> : ''}
            {mydata.pricediff ? <h3>aquacash discount &#8377; {mydata.pricediff}</h3> : ''} 
            {mydata.over_rate >=1 ? <div>
            	<div className="str_blk"><i className="m_star_rate"><img src={baseAssets+'images/web_imgs/star_filled.png'} width="16px" role="presentation"/></i>{mydata.over_rate} </div>
             {mydata.count >0 && mydata.dealcount <=1 ? <div className="views_eye"><img src={require('./../../../assets/images/visible.png')} alt=" " width="17" /> {mydata.count} {mydata.count >1 ? 'Views' : 'View'}</div> : ''}
            </div>: <div>
            <div className="str_blk"><i className="m_nostar_rate"><img src={baseAssets+'images/web_imgs/star_gray.png'} width="17px" role="presentation"/></i> </div>
             {mydata.count >0 && mydata.dealcount <=1 ? <div className="views_eye"><img src={require('./../../../assets/images/visible.png')} alt=" " width="17" /> {mydata.count} {mydata.count >1 ? 'Views' : 'View'}</div> : ''}
            </div>}
        </div>
    </Link>
  }
    {mydata.dealcount <=1 ? <Link className="share_list" onClick={()=>{this.ShareFunc(mydata.deal_id)}}>
    	<img src={baseAssets+'images/web_imgs/share1.png'} alt="share" />
    </Link> : ''}

	<div>
       <Panel className="share_panel" collapsible expanded={this.state.open}>
	        <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share">
	          <FacebookIcon size={32} round />
	        </FacebookShareButton>
	        <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share">
	          <TwitterIcon size={32} round />
	        </TwitterShareButton>
	        <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
	          <GooglePlusIcon size={32} round />
	        </GooglePlusShareButton>
	    </Panel>
   	</div>
   
    {/*{mydata.dealcount >= 2 ? '' : <a className="quick_buy_img" onClick={()=>this.addToCart(mydata.deal_id)}><img src={baseAssets+"images/icons/quick_buy.png"} alt=" " width="40px" /></a>}*/}
    {mydata.dealcount >= 2 ? '' : <a className="quick_buy_img" onClick={()=>this.addToQuickCart(mydata.deal_id)}><img src={require('./../../../assets/images/quick_buy.png')} alt=" " width="40" /></a>}
	{/* Modal for Replaceing the other cart items */}
    <Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
		<Modal.Header closeButton>
    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
  		</Modal.Header>
  		<Modal.Body>
  			<h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {mydata.title}?</h4>
  		</Modal.Body>
  		<Modal.Footer className="modal_footer">
			<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
			<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.replaceCartItems(mydata.deal_id,mydata.min_qty)}}>YES</Button></a>
  		</Modal.Footer>
	</Modal>

	{/* Modal for Showing the response of Already existing product */}
	<Modal className="m_pro_full_dtls_modal"  show={this.state.already_added_status} onHide={this.close}  >
		<Modal.Header closeButton>
    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
  		</Modal.Header> 
  		<Modal.Body>
  			<h4 style={{fontSize:'14px', color:'#333'}}>Product already added to the cart</h4>
  		</Modal.Body>
  		<Modal.Footer className="modal_footer">
				<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>OK</Button>
		</Modal.Footer>
	</Modal>
	
</div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Feed/pdeals.js
 **/